//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      // 会员码
      code: '6711358415844751483',
      // 手机号
      member_mobile: '',
      // 余额
      member_balance: 0,
      // 优惠券张数
      coupon_num: 0,
      // 积分
      member_score: 0,
      // 会员等级
      member_level_name: '1',
      // 头像
      member_head_url: '',
      // 会员码定时器
      timer: null,
      member_created_at: '' // 注册时间
    }
  },
  computed: {
    // 处理手机号加密
    secretMobile () {
      return this.member_mobile
        ? `${this.member_mobile.substr(0, 3)}****${this.member_mobile.substr(
          7
        )}`
        : ''
    },
    // logo背景
    logoStyle () {
      return this.member_head_url
        ? {
          background: `url("${this.member_head_url}") 0% 0% / 100% 100%`
        }
        : {}
    }
  },
  activated () {
    this.handleAuthCode()
    this.getMemberInfoByNo()
  },
  deactivated () {
    this.clear()
  },
  methods: {
    // 获取会员信息
    getMemberInfoByNo () {
      this.api.getMemberInfoByNo().then(res => {
        const data = res.data
        this.member_mobile = data.member_mobile
        this.member_created_at = data.created_at
        this.member_balance = data.member_balance
        this.coupon_num = data.coupon_num
        this.member_score = data.member_score
        this.member_level_name = data.member_level_name
        this.member_head_url =
          data.member_head_url || '../../../../static/imgs/logo_icon.png'
      })
    },
    // 处理会员条形码
    handleAuthCode () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.getCode()
      this.timer = setInterval(() => {
        this.getCode()
      }, 60 * 1000 * 5)
    },
    // 获取code码
    getCode () {
      this.api.generateDynamicCode().then(res => {
        this.code = res.data
        // 条形码渲染
        this.$nextTick(_ => {
          if (this.$refs.barcode) {
            this.JsBarcode('#barcode', this.code, {
              displayValue: false
            })
          }
        })
      })
    },
    // 页面跳转
    goToPga (path) {
      this.$router.push(path)
    },
    // 清空定时器等
    clear () {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    // 跳转小程序 查看积分商城
    goToXCX () {
      this.api.getMiniAppId().then(res => {
        this.code = res.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/home/index.vue